

import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import popperImg from 'resources/img/popper.svg';
import puffuIcon from 'resources/img/puffuIcon.svg';
import appstore from 'resources/img/appstore.svg';
import googledisabled from 'resources/img/googledisabled.svg';
import googleplay from 'resources/img/googleplay.svg';
import galaxystore from "resources/img/puffu/app/galaxystore.png";
import P from 'components/P';
import Inline from 'layouts/container/Inline';
import Dummy from 'components/Dummy';
import { useEffect, useState } from 'react';
import onestore from "resources/img/onestore.png";
function AppDown() {
    const timeout = 300;

    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(false);

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', (e) => {
            // 기본 브라우저 동작 방지
            e.preventDefault();
            // 이벤트를 상태로 저장
            setDeferredPrompt(e);
            // 설치 버튼을 보이도록 상태 변경
            setShowInstallButton(true);
        });
    }, []);

    const redirectToStore = (storeUrl) => {
        window.location.href = storeUrl;
    };

    const tryOpenApp = (schemeUrl, storeUrl) => {
        const start = Date.now();
        const ifr = document.createElement('iframe');
        ifr.style.display = 'none';
        ifr.src = schemeUrl;
        document.body.appendChild(ifr);

        setTimeout(() => {
            const end = Date.now();
            if (end - start < timeout + 200) {
                redirectToStore(storeUrl);
            }
            document.body.removeChild(ifr);
        }, timeout);
    };

    const handleAppStoreClick = () => {
        const iosUrl = 'https://apps.apple.com/kr/app/puffu/id6504068927';
        const appScheme = 'puffuios://action';

        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            tryOpenApp(appScheme, iosUrl);
        } else {
            redirectToStore(iosUrl);
        }
    };

    const handleOneStoreClick = () => {
        const onestoreUrl = 'https://m.onestore.co.kr/ko-kr/apps/appsDetail.omp?prodId=0000781106';
        const appScheme = 'puffuios://action';

        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            // tryOpenApp(appScheme, iosUrl);
        } else {
            redirectToStore(onestoreUrl);
        }
    };


    const handleGalaxyStoreClick = () => {
        const onestoreUrl = 'https://apps.samsung.com/appquery/appDetail.as?appId=com.androidpu.muinPu';
        const appScheme = 'puffuios://action';

        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            // tryOpenApp(appScheme, iosUrl);
        } else {
            redirectToStore(onestoreUrl);
        }
    };

    const handleGooglePlayClick = () => {
        if (deferredPrompt) {
            // 설치 프로세스 시작
            deferredPrompt.prompt();
            // 사용자가 선택 후 이벤트 초기화
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    
                } else {
                    
                }
                setDeferredPrompt(null);
                setShowInstallButton(false);
            });
        }
        const androidUrl = 'https://play.google.com/store/apps/details?id=com.puffu.puffupayment&hl=ko';
        const appScheme = 'puffu://action';

        if (/android/i.test(navigator.userAgent)) {
          tryOpenApp(appScheme, androidUrl);
        } else {
          redirectToStore(androidUrl);
        }
    };

    return (
        <Container height={"100dvh"}>
            <Container maxWidth={500}>
                <VerticalFlex gap={20}>
                    <FlexChild alignItems={"flex-end"} width={"100%"}>
                        <img src={popperImg} alt="Popper" />
                    </FlexChild>
                    <FlexChild>
                        <img src={puffuIcon} alt="Puffu Icon" />
                    </FlexChild>
                    <FlexChild>
                        <P size={"11vw"} weight={900} color={"rgba(254, 83, 31, 1)"}>반가워요!</P>
                        <Dummy height={"5vh"} />
                    </FlexChild>
                    <FlexChild>
                        <P size={"6vw"}>24시간 언제나</P>
                        <Inline>
                            <P size={"6vw"}>간편한 무인 매장</P>
                            <P size={"6vw"} color={"var(--point-color)"}>푸푸</P>
                            <P size={"6vw"}>입니다</P>
                        </Inline>
                    </FlexChild>
                    <FlexChild>
                        <img src={appstore} alt="App Store" onClick={handleAppStoreClick} style={{ cursor: 'pointer' }} />
                    </FlexChild>
                    <FlexChild>
                        <img src={onestore} alt="One Store" onClick={handleOneStoreClick} style={{ cursor: 'pointer' }} />
                    </FlexChild>
                    <FlexChild>
                        <img src={googleplay} alt="Google Play" onClick={handleGalaxyStoreClick} style={{ cursor: 'pointer' }} />
                        {/* <img src={googledisabled} alt="Google Play" /> */}
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default AppDown;